import React from 'react';
import { Input, Popover } from 'antd';
import { string, bool, func, shape, number } from 'prop-types';
import Button from '../../components/Button';
import NoImage from '../../assets/images/no-image-320x200.jpg';
import { constants, utils } from '../../devUtils';
import { ALERT_LYRA_VOUCHER_VALUES } from './constants';
import endPoints from '../../config/endPoints';
import { LyraCardGift, PopoverImage } from './StyledLyraCardGift';

const LyraGiftLandingCard = (props) => {
  const {
    history,
    product_type,
    padding,
    isMobileWindow = false,
    voucherAmount,
    OnLyraVourcherAmountChange,
    onStoreLyraGiftCard,
    onClearError,
    onChildEvents,
    amounts,
    slug,
    name,
    id,
  } = props;
  const onHoverFullImage = <PopoverImage src={endPoints.LYRA_GIFT_CARD.URL || NoImage} alt={endPoints.LYRA_GIFT_CARD.ALT} role="presentation" />;

  const handleAddToCart = () => {
    if (!voucherAmount) {
      onClearError(ALERT_LYRA_VOUCHER_VALUES, 'error');
      return null;
    }

    const cartItem = {
      key: `item-${Date.now()}`,
      slug: 'dynamic-gift-card',
      itemPrice: voucherAmount,
      quantity: 1,
    };

    const updatedCartList = [cartItem];

    const updatedOrderObj = {
      orderItemCount: 1,
      orderSummeryAmount: voucherAmount,
      shipping_fee_cents: 0,
      discountPersent: 0,
    };

    const lyraCartDummyObj = {
      cartList: updatedCartList,
      orderObj: updatedOrderObj,
      lyraCartItemCount: 1,
    };
    onStoreLyraGiftCard(lyraCartDummyObj);
    const { product_id = '', product_variation_id = '' } = amounts[0] || {};
    const payload = {
      product_id,
      free_field_value: voucherAmount,
    };
    onChildEvents('variationChange', { variation_id: product_variation_id, product_id, free_field_value: voucherAmount }, slug || name);
    onChildEvents('addToCart', payload, slug || name);

    return null;
  };


  return (
    <LyraCardGift padding={padding} classRemarks={product_type === 'merchandise' ? 'h-300' : 'h-250'}>
      {isMobileWindow ?
        <img src={endPoints.LYRA_GIFT_CARD.URL || NoImage} alt={endPoints.LYRA_GIFT_CARD.ALT} role="presentation" /> :
        <Popover content={onHoverFullImage} placement="left" >
          <img src={endPoints.LYRA_GIFT_CARD.URL || NoImage} alt={endPoints.LYRA_GIFT_CARD.ALT} role="presentation" classRemarks={product_type === 'merchandise' ? 'manipal-img' : ''} />
        </Popover>}
      <div className="price-button-row">
        <Input
          placeholder="Enter Amount"
          className="price-input"
          type="number"
          onChange={({ target: { value } }) => OnLyraVourcherAmountChange(Number(value))}
        />
        <Button
          type="primary"
          onClick={() => handleAddToCart()}
        >
          Add to Cart
        </Button>
      </div>
    </LyraCardGift>
  );
};

LyraGiftLandingCard.defaultProps = {
  product_type: '',
  padding: '',
  voucherAmount: 0,
};

LyraGiftLandingCard.propTypes = {
  isMobileWindow: bool.isRequired,
  product_type: string,
  padding: string,
  voucherAmount: number,
  history: shape({}).isRequired,
  OnLyraVourcherAmountChange: func.isRequired,
  onStoreLyraGiftCard: func.isRequired,
  onClearError: func.isRequired,
};

export default LyraGiftLandingCard;



// WEBPACK FOOTER //
// client/containers/GiftCardLanding/LyraGiftLandingCard .js